module.exports = __webpack_public_path__ + "img/diamonds.5853139a.png";